import { ObservacionCompromiso, RegistrarObservacionOCompromisoEnPlanDePagoArgs } from '../tipos';

export type TiposDeObservacionId = ObservacionCompromiso['tipo'];
export type TipoCompromiso = ObservacionCompromiso;

export type TipoNuevoCompromiso = Omit<
    RegistrarObservacionOCompromisoEnPlanDePagoArgs,
    'idPlanDePago'
>;

export const tiposDeComentarioOptions: Array<{ value: TiposDeObservacionId; text: string }> = [
    { value: 'retiro', text: 'Retiro' },
    { value: 'congela', text: 'Congela' },
    { value: 'no-contesta', text: 'No contesta' },
    { value: 'telefono-apagado', text: 'Teléfono apagado/buzón' },
    { value: 'cortan-llamada', text: 'Cortan la llamada' },
    { value: 'al-dia', text: 'Está al día' },
    { value: 'ya-pagado', text: 'Pago ya realizado' },
    { value: 'aviso-cobranza', text: 'Aviso de cobranza entregado personalmente' },
    { value: 'mensaje-cobranza', text: 'Mensaje de cobranza enviado' },
    { value: 'cheque-protestado', text: 'Cheque protestado' },
    { value: 'otro', text: 'Otro' },
];

export const mapaDeTitulos: Readonly<Record<
    TiposDeObservacionId,
    string
>> = tiposDeComentarioOptions.reduce(
    (acc, x) => {
        acc[x.value] = x.text;
        return acc;
    },
    // tslint:disable-next-line:no-any
    {} as any,
);

export interface TarjetaPropsComunes {
    readonly fechaDeRegistro: string;
    readonly nombreDelUsuario: string;
    readonly fechaAdicional?: string;
    readonly observaciones: string;
    alEliminar(): void;
}



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Observaciones/tipos.ts